import firebase from 'firebase/app'
import { firebaseAction } from 'vuexfire'

import router from '@/router'

const db = firebase.firestore()
const usersCollection = db.collection('user_accts')
const keysCollection = db.collection('keys')

export default {
  userSignUp ({dispatch, commit}, {user, provider, ...payload}) {
    user.updateProfile({ displayName: payload.name})
    const userData = {
      uid: user.uid,
      name: payload.name,
      email: payload.email,
      company: payload.company || '',
      signInMethod: provider,
      total: 0,
      usage: {
        current: 0
      }
    }
    dispatch('createUser', userData).then(() => {
      commit('setUser', {
        bound: true,
        ...userData
      })
      // if (provider != 'email') {
      //   location.href = "/"
      // } else {
        commit('setError', null)
        commit('setLoading', false)
        router.push('settings')
        // dispatch('loadUserStripe', userData)
      // }
    })
  },
  userSignUpWithEmail ({dispatch, commit}, payload) {
    commit('setLoading', true)
    firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password).then(({user}) => {
      dispatch('userSignUp', {
        ...payload,
        provider: 'email',
        user
      })
    })
    .catch(error => {
      console.log(error)
      commit('setError', error.message)
      commit('setLoading', false)
    })
  },
  userSignUpWithGithub ({dispatch, commit}, payload) {
    const provider = new firebase.auth.GithubAuthProvider()
    provider.addScope('user:email')
    provider.addScope('read:user')
    const auth = firebase.auth()
    auth.signInWithPopup(provider).then((result) => {
      const token = result.credential.accessToken
      const user = result.user
      usersCollection.doc(user.uid).update({
        name: user.providerData[0].displayName,
      }).then(() => {
        // location.href = "/"
        commit('setError', null)
        commit('setLoading', false)
        router.push('settings')
      }).catch(() => {
        dispatch('userSignUp', {
          name: user.providerData[0].displayName,
          email: user.providerData[0].email,
          company: '',
          provider: 'github',
          user: user
        })
      })
    }).catch((error) => {
      console.log(error)
      commit('setError', error.message)
      commit('setLoading', false)
    })
  },
  userSignUpWithGoogle ({dispatch, commit}, payload) {
    const provider = new firebase.auth.GoogleAuthProvider()
    provider.addScope('email')
    provider.addScope('profile')
    const auth = firebase.auth()
    auth.signInWithPopup(provider).then((result) => {
      const token = result.credential.accessToken
      const user = result.user
      usersCollection.doc(user.uid).update({
        name: user.providerData[0].displayName,
      }).then(() => {
        // location.href = "/"
        commit('setError', null)
        commit('setLoading', false)
        router.push('settings')
      }).catch(() => {
        dispatch('userSignUp', {
          name: user.providerData[0].displayName,
          email: user.providerData[0].email,
          company: '',
          provider: 'google',
          user: user
        })
      })
    }).catch((error) => {
      console.log(error)
      commit('setError', error.message)
      commit('setLoading', false)
    })
  },
  userSignIn ({commit}, payload) {
    commit('setLoading', true)
    firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
    .then(({user}) => {
      // commit('setUser', {
      //   id: user.uid,
      //   email: user.email,
      // })
      commit('setError', null)
      commit('setLoading', false)
      router.push('settings')
      // location.href = "/"
    })
    .catch(error => {
      commit('setError', error.message)
      commit('setLoading', false)
    })
  },
  autoSignIn ({dispatch, commit}, payload) {
    commit('setUser', {
      email: payload.email || payload.providerData[0].email || (payload.uid + '@unknown.com'),
      name: payload.name || payload.displayName || payload.providerData[0].displayName || '',
      uid: payload.uid,
      bound: true
    })
    commit('setLoading', true)
    dispatch('setUser', {
      ref: usersCollection.doc(payload.uid),
      callback: (user) => {
        if (user) {
          dispatch('loadUserStripe', user)
        }
        commit('setLoading', false)
        commit('setError', null)
        // router.push('/settings')
      }
    })
  },
  userSignOut ({commit}) {
    firebase.auth().signOut().then(() => {
      commit('setUser', null)
      commit('reset')
      router.push('/login')
    })
  },

  setUser: firebaseAction(({bindFirebaseRef, state}, {ref, callback}) => {
    if (state.user && state.user.uid === ref.id && !state.user.bound) {
      (callback)(false)
      return
    }
    bindFirebaseRef('user', ref).then(() => {
      (callback)(state.user)
    })
  }),
  updateUser ({dispatch, commit, getters}, payload) {
    const {bound, ...userData} = payload
    commit('setLoading', true)
    return usersCollection.doc(getters.user.uid).set(userData, {
      merge: true
    }).then(() => {
      commit('setLoading', false)
      return Promise.resolve()
    })
  },
  createUser ({dispatch, commit, getters}, payload) {
    const {bound, ...userData} = payload
    commit('setLoading', true)
    return usersCollection.doc(userData.uid).set(userData, {
      merge: true
    }).then(() => {
      commit('setLoading', false)

      return Promise.resolve()
    })
  },

  loadKeys ({dispatch, commit, getters}) {
    commit('setLoading', true)
    dispatch('loadUserKeys', {
      ref: keysCollection.where('user', '==', usersCollection.doc(getters.user.uid)),
      callback: () => {
        commit('setLoading', false)
        commit('setError', null)
      }
    })
    return
  },
  loadUserKeys: firebaseAction(({bindFirebaseRef, state}, { ref, callback }) => {
    if (state.keys !== null) {
      (callback)(false)
      return
    }
    callback(true)
    // bindFirebaseRef('keys', ref).then(() => {
    //   (callback)(true)
    // })
  }),

  resetPasswordRequest ({commit, getters}, payload) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      firebase.auth().sendPasswordResetEmail(payload && payload.email || getters.user.email)
      .then(() => {
        commit('setError', null)
        resolve()
      })
      .catch((error) => {
        commit('setError', error.message)
        reject(error)
      })
      .finally(() => commit('setLoading', false))
    })
  },

  savePaymentMethod ({dispatch, commit}, payload) {
    commit('setLoading', true)
    return dispatch('submitStripeCard', payload)
    .then(({card: stripeCard, customer: stripeCustomer}) => {
      commit('setStripeCustomer', stripeCustomer)
      commit('setStripeCard', stripeCard)
      commit('setLoading', false)
      commit('setError', null)
      return Promise.resolve({card: stripeCard, customer: stripeCustomer})
    })
    .catch((error) => {
      commit('setError', error.message)
      commit('setLoading', false)
      return Promise.reject(error)
    })
  }
}